<template>
  <div class="companies">
    <SectionHeader :title="$t('meta.projects')">
      <template v-slot:breadcrumbs>
        <BreadCrumbs :items="[{ text: $t('projects.addProject') }]" />
      </template>
      <template slot="meta">
        <Link :to="`/company/projects`" class="button button-green button-round button-small">{{
          $t('projects.allProjects')
        }}</Link>
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('projects.addProject') }}</h3>
          </header>
          <div class="content-body">
            <ProjectForm @submit="createProject" :companyUuid="companyUser.company_uuid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectForm from '@/views/companies/projects/form'

import BreadCrumbs from '@/components/BreadCrumbs'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import projectsApi from '@/api/projects'

export default {
  name: 'new_company_project',
  inject: ['companyUser'],
  components: { BreadCrumbs, CompanyNav, ProjectForm, SectionHeader },
  methods: {
    createProject: async function (project) {
      const createdProject = await projectsApi.create({
        ...project,
        company_uuid: this.companyUser.company_uuid,
      })
      if (createdProject) {
        await this.$router.push('/company/projects')
      }
    },
  },
}
</script>
